import { sendRequest } from "../../hooks/requests/useRequest";

export async function getAllTypeService ()
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrderServiceType/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}